export default __webpack_public_path__ + "sounds/wrong1.mp3";